import { ApiQueryParams } from '@frontend/api-utils';
import { MultiObjectSelectInput } from '@frontend/components/basic-forms';
import { UserGroupClient } from '@frontend/group/api';
import { GroupQueryParams, IGroup } from '@frontend/group/types';
import React, { useState } from 'react';

const ID = 'multi-user-group-select';
export interface MultiUserGroupSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    onChange?: (newValue: string[]) => void;
    onChangeObject?: (newValue: IGroup[]) => void;
    value?: string[];
    searchValueOverwrite?: string;
    className?: string;
    disabled?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<GroupQueryParams>;
    disableFetch?: boolean;
    subset?: string[];
    onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    isOpenOverwrite?: boolean;
    queryKeyOverride?: string;
}

export const MultiUserGroupSelect = (props: MultiUserGroupSelectProps) => {
    const [v, cV] = useState<IGroup[]>([]);
    return (
        <MultiObjectSelectInput<IGroup, GroupQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            key={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'User groups'}
            className={props.className}
            onChange={(v: IGroup[]) => {
                props.onChange && props.onChange(v.map((user) => user.id));
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={props.value || v.map((user) => user.id) || []}
            searchValueOverwrite={props.searchValueOverwrite}
            isClearable={props.isClearable}
            multiFetch={(ids) => UserGroupClient.resolveUserGroups(ids).then((res) => res.results)}
            fetch={(arg) => UserGroupClient.fetchUserGroups({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(user: IGroup) => user.name}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            subset={props.subset}
            isOpenOverwrite={props.isOpenOverwrite}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: props.queryKeyOverride ?? 'user_group_id',
                          fetch: (id) =>
                              UserGroupClient.resolveUserGroups(id).then((res) => {
                                  return res.results;
                              })
                      }
                    : undefined
            }
        />
    );
};
